export enum CommunityArticleAutopilotMode {
    DISABLED = 0,
    AUTO = 1,
    MANUAL = 2
}
